<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M2.5 5.27691C2.5 4.04961 3.49492 3.05469 4.72222 3.05469H15.2778C16.5051 3.05469 17.5 4.04961 17.5 5.27691V6.94358H2.5V5.27691Z"
            fill="#E4EBFF"
        />
        <path
            d="M6.38892 3.05425V0.832031"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.6111 3.05425V0.832031"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.2778 3.05469H4.72222C3.49492 3.05469 2.5 4.04961 2.5 5.27691V14.7214C2.5 15.9487 3.49492 16.9436 4.72222 16.9436H15.2778C16.5051 16.9436 17.5 15.9487 17.5 14.7214V5.27691C17.5 4.04961 16.5051 3.05469 15.2778 3.05469Z"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.5 6.94531H17.5"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 9.16797C9.3878 9.16797 8.88892 9.66686 8.88892 10.2791C8.88892 10.8913 9.3878 11.3902 10 11.3902C10.6122 11.3902 11.1111 10.8913 11.1111 10.2791C11.1111 9.66686 10.6122 9.16797 10 9.16797Z"
            fill="#007AFF"
        />
        <path
            d="M13.8889 11.3902C14.5012 11.3902 15.0001 10.8913 15.0001 10.2791C15.0001 9.66686 14.5012 9.16797 13.8889 9.16797C13.2767 9.16797 12.7778 9.66686 12.7778 10.2791C12.7778 10.8913 13.2767 11.3902 13.8889 11.3902Z"
            fill="#007AFF"
        />
        <path
            d="M10 12.5C9.3878 12.5 8.88892 12.9989 8.88892 13.6111C8.88892 14.2233 9.3878 14.7222 10 14.7222C10.6122 14.7222 11.1111 14.2233 11.1111 13.6111C11.1111 12.9989 10.6122 12.5 10 12.5Z"
            fill="#007AFF"
        />
        <path
            d="M6.11111 12.5C5.49889 12.5 5 12.9989 5 13.6111C5 14.2233 5.49889 14.7222 6.11111 14.7222C6.72333 14.7222 7.22222 14.2233 7.22222 13.6111C7.22222 12.9989 6.72333 12.5 6.11111 12.5Z"
            fill="#007AFF"
        />
        <path
            d="M13.8889 12.5C13.2767 12.5 12.7778 12.9989 12.7778 13.6111C12.7778 14.2233 13.2767 14.7222 13.8889 14.7222C14.5011 14.7222 15 14.2233 15 13.6111C15 12.9989 14.5011 12.5 13.8889 12.5Z"
            fill="#007AFF"
        />
    </svg>
</template>
